import _ from 'lodash';
import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from 'components/common/button';

class InlineImageButton extends React.Component {
  constructor(props) {
    super(props);
    _.bindAll(this, ['onAttach']);
  }

  onAttach(event) {
    this.input.click();
    event.preventDefault();
  }

  render() {
    let buttonClassName = classnames(`${this.props.className}-inlineImageButton`, 'fa', 'fa-image');
    return (
      <label key="label" className="draftStylesMenu-item" title="Inline Image">
        <input
          accept={this.props.accept}
          className="inlineImageInput"
          onChange={this.props.onInsertImage}
          ref={input => (this.input = input)}
          style={{ display: 'none' }}
          type="file"
        />
        <StyledImageButton
          className={buttonClassName}
          onBlur={this.props.onInsertImageBlur}
          onClick={this.onAttach}
          ref={button => (this.button = button)}
          tabIndex="-1"
        />
      </label>
    );
  }
}

InlineImageButton.propTypes = {
  accept: PropTypes.string,
  className: PropTypes.string,
  onInsertImage: PropTypes.func.isRequired,
  onInsertImageBlur: PropTypes.func,
};

export default InlineImageButton;

const StyledImageButton = styled(Button)`
  background: inherit;
  background-color: transparent;
  border: none;
  color: inherit;
  padding: 0;

  &:hover {
    background-color: transparent;
  }

  &:focus {
    border: 1px solid ${p => p.theme.colors.gray200};
    border-radius: 4px;
  }
`;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/inline_image_button.jsx